import React, { useState } from 'react'
import { CircularProgress } from '@mui/material'
import { toast, ToastContainer } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import 'react-toastify/dist/ReactToastify.css'
import './AideHebergement.css'

const AideHebergement = () => {
  const navigate = useNavigate()

  const [formData, setFormData] = useState({
    nom: '',
    email: '',
    personnes: '',
    type: 'Studio',
    pieces: '',
    chambres: '',
    sdb: '',
    whatsapp: '',
    message: '',
  })

  const [loading, setLoading] = useState(false)

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    try {
      const res = await fetch(
        'https://esisa-portail-intranet-back.vercel.app/contact/send-hebergement',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(formData),
        }
      )

      const data = await res.json()

      if (res.ok) {
        toast.success('✅ Votre demande a été envoyée avec succès.', {
          position: 'bottom-center',
          autoClose: 3000,
        })
        setFormData({
          nom: '',
          email: '',
          personnes: '',
          type: 'Studio',
          pieces: '',
          chambres: '',
          sdb: '',
          whatsapp: '',
          message: '',
        })

        setTimeout(() => {
          navigate('/')
        }, 3500)
      } else {
        toast.error('❌ Une erreur est survenue. Veuillez réessayer.', {
          position: 'bottom-center',
          autoClose: 4000,
        })
      }
    } catch (error) {
      toast.warning('⚠️ Problème de connexion.', {
        position: 'bottom-center',
        autoClose: 4000,
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="hebergement-container">
      <h1 className="hebergement-title">Service d'Aide à l'Hébergement</h1>

      <form className="hebergement-form" onSubmit={handleSubmit}>
        <input type="text" name="nom" value={formData.nom} onChange={handleChange} required placeholder="Nom complet" />
        <input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="Adresse e-mail" />

        <select style={{ fontSize: '12px' }} name="personnes" value={formData.personnes} onChange={handleChange} required>
          <option value="">Nombre de personnes</option>
          {[1, 2, 3, 4].map((num) => (
            <option key={num} value={num}>{num}</option>
          ))}
        </select>

        <select style={{ fontSize: '12px' }} name="type" value={formData.type} onChange={handleChange}>
          <option value="Studio">Studio</option>
          <option value="Appartement">Appartement</option>
        </select>

        <select style={{ fontSize: '12px' }} name="pieces" value={formData.pieces} onChange={handleChange} required>
          <option value="">Nombre de pièces</option>
          {[1, 2, 3, 4, 5].map((num) => (
            <option key={num} value={num}>{num}</option>
          ))}
        </select>

        <select style={{ fontSize: '12px' }} name="chambres" value={formData.chambres} onChange={handleChange} required>
          <option value="">Nombre de chambres</option>
          {[1, 2, 3].map((num) => (
            <option key={num} value={num}>{num}</option>
          ))}
        </select>

        <select style={{ fontSize: '12px' }} name="sdb" value={formData.sdb} onChange={handleChange} required>
          <option value="">Nombre de salles de bains</option>
          {[1, 2, 3, 4].map((num) => (
            <option key={num} value={num}>{num}</option>
          ))}
        </select>

        <input type="tel" name="whatsapp" value={formData.whatsapp} onChange={handleChange} required placeholder="Numéro WhatsApp" />

        <textarea name="message" value={formData.message} onChange={handleChange} placeholder="Message (optionnel)" rows="4" />

        <button type="submit" disabled={loading}>
          {loading ? <CircularProgress size={24} color="inherit" /> : 'Envoyer la demande'}
        </button>
      </form>

      <ToastContainer />
    </div>
  )
}

export default AideHebergement
